/** How worrying the margin level is: fine, at or below margin call (amber), or close to stop-out (red). */
export type MarginTone = 'none' | 'ok' | 'warn' | 'danger';

/** Within this share above the stop-out level the level shows red: a small move closes positions. */
export const NEAR_STOP_OUT = 1.2;

export function marginTone(
  figures: { margin: number; marginLevel: number; marginCall: boolean },
  levels: { marginCallLevel: number; stopOutLevel: number },
): MarginTone {
  if (figures.margin === 0) return 'none';
  if (levels.stopOutLevel > 0 && figures.marginLevel <= levels.stopOutLevel * NEAR_STOP_OUT) return 'danger';
  if (figures.marginCall || (levels.marginCallLevel > 0 && figures.marginLevel <= levels.marginCallLevel)) {
    return 'warn';
  }
  return 'ok';
}

export const TONE_TEXT: Record<MarginTone, string | null> = {
  none: null,
  ok: null,
  warn: 'Margin call',
  danger: 'Near stop out',
};
